import axiosInstanceNew from "../lib/axiosinstanceNew";

const SubAdmins = class {

    constructor(){
        this.baseUrl="subadmin";
    }
//Add subAdmin
async addAdmin (id, data = []){
  return(await axiosInstanceNew.put(`${this.baseUrl}/${id}`,data))
}
  // subAdmin
  async Getlist (data=[]) {
    return (await axiosInstanceNew.get(`${this.baseUrl}?designation=supervisor`));
  }
  async list () {
    return (await axiosInstanceNew.get(`${this.baseUrl}`));
  }
  async listbyid (id) {
    return (await axiosInstanceNew.get(`${this.baseUrl}/${id}`));
  }
}

export default new SubAdmins();